import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import * as yup from "yup";
import { toastResponseError } from "../../../utils/responseMessageHelper";

export interface PrintUserFormValues {
  email: string;
  uid: string;
  password: string;
  password_confirmation: string;
}

export const printUserFormHelper = (
  t: TFunction,
  submitAction: (data: any) => Promise<any>,
  closeRightPanel: () => void,
  isEditMode: boolean,
  initialValues?: Partial<PrintUserFormValues>,
) => ({
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: false,
  initialValues: {
    email: initialValues?.email || "",
    uid: initialValues?.uid || "",
    password: "",
    password_confirmation: "",
  },
  validationSchema: isEditMode
    ? yup.object().shape({
        email: yup
          .string()
          .email(t("error.invalid", { field: t("tools.email") }))
          .required(t("error.required", { field: t("tools.email") })),
      })
    : yup.object().shape({
        email: yup
          .string()
          .email(t("error.invalid", { field: t("tools.email") }))
          .required(t("error.required", { field: t("tools.email") })),
        uid: yup
          .string()
          .required(t("error.required", { field: t("tools.uid") })),
        password: yup
          .string()
          .required(t("error.required", { field: t("tools.password") })),
        password_confirmation: yup
          .string()
          .oneOf([yup.ref("password")], t("error.passMatch"))
          .required(
            t("error.required", { field: t("tools.passwordConfirmation") }),
          ),
      }),
  onSubmit: (
    values: PrintUserFormValues,
    { setSubmitting }: FormikHelpers<PrintUserFormValues>,
  ) => {
    const data: any = { email: values.email };

    if (!isEditMode) {
      data.uid = values.uid;
      data.password = values.password;
      data.password_confirmation = values.password_confirmation;
    }

    submitAction({ external_print_user: data })
      .then(() => closeRightPanel())
      .catch((response: string) => {
        toastResponseError(response);
      })
      .finally(() => setSubmitting(false));
  },
});
